import React from 'react';
import { useRef, useState } from 'react';
import { BsTrash } from 'react-icons/bs';
import Editable from '../../Utils/editable';
import './css/quote.css';

type quoteProps = {
	index: number;
	id?: string;
	quote: string;
	metadata: string;
	quotes: any[];
	isMine: boolean;
	setQuotes: (quotes: any[]) => void;
	setIsChanged: (isChanged: boolean) => void;
};

export default function Quote(props: quoteProps) {
	const [content, setQuote] = useState(props.quote);
	const [metadata, setMetadata] = useState(props.metadata);

	const quoteRef = useRef<null>(null);
	const metadataRef = useRef<null>(null);

	const editQuote = (index: number, content: string, metadata: string) => {
		const updatedQuotes = props.quotes.slice();
		const editedQuote = updatedQuotes[index];
		updatedQuotes[index] = {
			...editedQuote,
			content: content,
			metadata: metadata
		};
		props.setQuotes(updatedQuotes);
	};

	const removeQuote = () => {
		const updatedQuotes = props.quotes.slice();
		updatedQuotes.splice(props.index, 1);
		props.setQuotes(updatedQuotes);
		props.setIsChanged(true);
	};

	return (
		<div>
			<div className="leading-normal mt-0 mb-2 text-gray-500 text-left mx-auto px20">
				<i className="mr-2 text-sm text-gray-500" />
				<div className="flex flex-row justify-center">
					<div className="w-3/12"></div>
					<div className="w-6/12  border-2 dark:border-gray-300 border-gray-400 rounded-xl">
						<Editable
							text={content}
							placeholder="Click here to write a quote"
							childRef={quoteRef}
							type="textarea"
							className="font-semibold leading-normal transition-colors duration-500 p-2"
							textColor="text-gray-500 dark:text-gray-100 transition-all duration-500"
						>
							<textarea
								ref={quoteRef}
								name="name"
								className="quoteStyle"
								placeholder=""
								disabled={!props.isMine}
								value={content}
								onChange={(e) => {
									props.setIsChanged(true);
									setQuote(e.target.value);
								}}
								onBlur={() => editQuote(props.index, content, metadata)}
							/>
						</Editable>
						<Editable
							text={metadata}
							placeholder="― Click here to add additional info"
							childRef={metadataRef}
							type="input"
							className="font-serif leading-normal transition-colors duration-500 p-2 text-right"
							textColor="text-gray-500 dark:text-gray-100 transition-all duration-500"
						>
							<input
								ref={metadataRef}
								type="text"
								name="name"
								className="quoteStyle"
								placeholder=""
								disabled={!props.isMine}
								value={metadata}
								onChange={(e) => {
									setMetadata(e.target.value);
									props.setIsChanged(true);
								}}
								onBlur={() => editQuote(props.index, content, metadata)}
							/>
						</Editable>
					</div>
					<div className=" my-auto w-3/12">
						{props.isMine && (
							<div
								className="lg:ml-16 flex justify-center items-center h-12 w-12 text-gray-800 dark:text-white
									hover:text-white hover:bg-red-400 transition-all duration-500 ease-linear 
									hover:rounded-xl rounded-3xl cursor-pointer hover:shadow-lg"
								onClick={() => removeQuote()}
							>
								<BsTrash size="22" />
							</div>
						)}
					</div>
				</div>
			</div>
			<div className="border-t mt-8 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center w-6/12 mx-auto" />
		</div>
	);
}
